import apiManager from '@/services/API/apiManager'
const getAdminInformation = async () => {
	const adminInfo = apiManager.axios
		.get(`/v1/admin/profile`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return adminInfo
}

const updateAdminInformation = async (updateObj, file) => {
	const formData = new FormData()
	apiManager.axios.defaults.timeout = 20000
	apiManager.axios.defaults.headers.post['Content-Type'] =
		'multipart/form-data'

	formData.append('firstName', updateObj.firstName)
	formData.append('lastName', updateObj.lastName)
	formData.append('phone', updateObj.phone)
	formData.append('specialization', updateObj.specialization)
	formData.append('pictureUrl', file)
	const updateInfo = apiManager.axios
		.patch(`/v1/admin/profile`, formData)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return updateInfo
}
export default {
	getAdminInformation,
	updateAdminInformation,
}
